// Main exports - Import first to create local bindings
import { TrackingSSEClient } from './sse-client';
import { TrackingSession } from './tracking-session';
export { TrackingSSEClient, TrackingSession };

// Types
export type {
  SSEConnectionConfig,
  SSEEventMap,
  SSEEventHandler
} from './sse-client';

export type {
  TrackingSessionConfig,
  TrackingSessionState,
  TrackingSessionListener
} from './tracking-session';

// Import types needed for factory function signatures
import type { SSEConnectionConfig } from './sse-client';
import type { TrackingSessionConfig } from './tracking-session';

// Convenience factory functions
export function createSSEClient(config: SSEConnectionConfig = {}) {
  return new TrackingSSEClient(config);
}

export function createTrackingSession(config: TrackingSessionConfig = {}) {
  return new TrackingSession(config);
}

// Version
export const VERSION = '0.1.0';